import { toast } from 'react-toastify';
function toastSuccess(message, timeout) {
    toast.success(message, {
        position: 'top-center',
        autoClose: timeout ?? 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        className: 'toast-base toast-success',
    });
}
export default toastSuccess;
